import { c as _c } from "react/compiler-runtime";
import { useFlag, useVariant } from "@unleash/nextjs/client";
export function useWalletFlags() {
  const $ = _c(2);
  const flags = {
    solanaTokenSendEnabled: useFlag("solana_token_send_enabled"),
    coinbase_one_banner_enabled: useFlag("coinbase_one_banner_enabled"),
    chest_reminder_banner_enabled: useFlag("chest_reminder_banner_enabled"),
    token_watchlist_enabled: useFlag("token_watchlist_enabled"),
    multiTraitOffersEnabled: useFlag("multi_trait_offers_enabled")
  };
  const {
    enabled,
    name,
    payload
  } = useVariant("enable_swap_usd_input");
  if (enabled) {
    flags.usdSwapInputEnabled = true;
    if (name === "disabled_tokens" && payload?.value) {
      let t0;
      if ($[0] !== payload.value) {
        t0 = payload.value.split(",");
        $[0] = payload.value;
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      flags.usdSwapInputDisabledTokens = t0;
    }
  }
  return flags;
}